import React, { useEffect, useRef, useCallback } from 'react';

const IframeMyClaim = ({ 
  url, 
  claimId,
  onEvent,
  onCalculationComplete,
  onSaved,
  className = ''
}) => {
  const iframeRef = useRef(null);

  // Handle messages from iframe
  const handleMessage = useCallback((event) => {
    // Verify origin for security
    if (!event.origin.includes('myclaim') && !event.origin.includes('dat.de')) {
      return;
    }

    try {
      const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      
      console.log('DAT iframe message:', data);

      // Handle different event types
      if (data.type === 'refresh_calculation' || data.event === 'refresh_calculation') {
        if (onCalculationComplete && data.calculation) {
          onCalculationComplete(data, claimId, data.contractType);
        }
      }

      if (data.type === 'inbox_templateSaved' || data.event === 'inbox_templateSaved') {
        if (onSaved) {
          onSaved(data, claimId, data.contractType);
        }
      }

      // Generic event handler
      if (onEvent) {
        onEvent(data.type || data.event || 'unknown', data, claimId);
      }
    } catch (error) {
      console.error('Error parsing iframe message:', error);
    }
  }, [claimId, onEvent, onCalculationComplete, onSaved]);

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handleMessage]);

  if (!url) {
    return (
      <div className="flex items-center justify-center h-96 bg-gray-50 rounded-lg border border-gray-200">
        <p className="text-gray-500">Keine URL verfügbar</p>
      </div>
    );
  }

  return (
    <iframe
      ref={iframeRef}
      src={url}
      className={`w-full border-0 ${className}`}
      style={{ minHeight: '700px', height: '80vh' }}
      allow="camera; microphone"
      title="DAT myClaim"
    />
  );
};

export default IframeMyClaim;
